import React from 'react';
import { useI18n } from '@shopify/react-i18n';
import enAppTranslation from './locales/data/json/en.json';
import { AppProvider } from '@shopify/polaris';
import enPolarisCoreTranslation from '@shopify/polaris/locales/en.json';

function I18nAppProvider(props) {
  const [i18nCorePolaris] = useI18n({
    id: 'Polaris',
    fallback: enPolarisCoreTranslation,
    async translations(locale) {
      return import(`@shopify/polaris/locales/${locale}.json`).then(
        dictionary => dictionary && dictionary.default
      );
    }
  });
  // eslint-disable-next-line no-unused-vars
  const [_, ShareAppTranslations] = useI18n({
    id: 'AdminHTML',
    fallback: enAppTranslation,
    async translations(locale) {
      return import(`./locales/data/json/${locale}.json`).then(dictionary => {
        return dictionary && dictionary.default;
      });
    }
  });

  return (
    <AppProvider i18n={i18nCorePolaris.translations}>
      <ShareAppTranslations>
        {props.children}
      </ShareAppTranslations>
    </AppProvider>
  );
}

export default I18nAppProvider;